export const environment = {
  production: false,
  apiURL: 'http://149.28.110.129/api'
};